jQuery(function ($) {
  function lockFocus(e) {
    const isTabPressed = e.key === "Tab" || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    e.preventDefault();

    if (focusableElements.length === 1) {
      focusableElements[0].focus();
    } else {
      if (e.shiftKey) {
        focusableElementsCurrentIndex--;
        if (focusableElementsCurrentIndex < 0) {
          focusableElementsCurrentIndex = focusableElements.length - 1;
        }
      } else {
        focusableElementsCurrentIndex++;
        if (focusableElementsCurrentIndex >= focusableElements.length) {
          focusableElementsCurrentIndex = 0;
        }
      }

      $.each(focusableElements, function () {
        $(this).removeClass("force-focus");
      });

      $(focusableElements[focusableElementsCurrentIndex]).focus();

      if ($(focusableElements[focusableElementsCurrentIndex]).is("a")) {
        $(focusableElements[focusableElementsCurrentIndex]).addClass(
          "force-focus"
        );
      }

      const focusableElement = $(".force-focus")[0];

      if (focusableElement) {
        focusableElement.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "nearest",
        });
      }
    }
  }

  let focusableElements = [];
  let focusableElementsCurrentIndex = -1;

  // Image modal
  const modalsNews = $(".modal-aandeslag");
  const triggersNews = $(".aandeslag-trigger");
  const closeButtonNews = $(".close-news-button");

  function showDialogNews(index) {
    modalsNews
      .eq(index)
      .addClass("show-modal-aandeslag")
      .removeClass("invisible opacity-0");
    document.body.style.overflow = "hidden";

    focusableElements = [];
    focusableElements.push($(".close-news-button").eq(index));
    focusableElements.push($(".modal-content").eq(index));
    focusableElementsCurrentIndex = 0;

    $(document).on("keydown", lockFocus);
  }

  function closeDialogNews(index) {
    modalsNews
      .eq(index)
      .removeClass("show-modal-aandeslag")
      .addClass("invisible opacity-0");
    document.body.style.overflow = "auto";
    focusableElementsCurrentIndex = -1;
    $(document).off("keydown", lockFocus);
  }

  function toggleModalNews(index) {
    if (modalsNews.eq(index).hasClass("show-modal-aandeslag")) {
      closeDialogNews(index);
    } else {
      showDialogNews(index);
    }
  }

  triggersNews.on("click keydown", function (event) {
    if (
      event.type === "click" ||
      (event.type === "keydown" && event.which === 13)
    ) {
      const index = triggersNews.index(this);
      toggleModalNews(index);
    }
  });

  closeButtonNews.on("click", function (event) {
    event.stopPropagation();
    const index = closeButtonNews.index(this);
    closeDialogNews(index);
  });

  function windowOnClickNews(event) {
    modalsNews.each(function (index) {
      if (event.target === this) {
        toggleModalNews(index);
      }
    });
  }

  $(document).on("click", windowOnClickNews);

  // Contactpersonen modal
  // const modalsContact = $(".modal-contactpersonen");
  // const triggersContact = $(".contactpersonen-trigger");
  // const closeButtonContact = $(".close-contactpersonen-button");

  // function showDialogContact(index) {
  //   modalsContact
  //     .eq(index)
  //     .addClass("show-modal-contactpersonen")
  //     .removeClass("invisible opacity-0");
  //   document.body.style.overflow = "hidden";

  //   document.body.classList.add("show-modal");

  //   focusableElements = [];
  //   focusableElements.push($(".close-contactpersonen-button").eq(index));
  //   focusableElements.push($(".modal-content").eq(index));
  //   focusableElements.push($(".modal-content-link").eq(index));
  //   focusableElementsCurrentIndex = 0;

  //   $(document).on("keydown", lockFocus);
  // }

  // function closeDialogContact(index) {
  //   modalsContact
  //     .eq(index)
  //     .removeClass("show-modal-contactpersonen")
  //     .addClass("invisible opacity-0");
  //   document.body.style.overflow = "auto";

  //   document.body.classList.remove("show-modal");

  //   focusableElementsCurrentIndex = -1;
  //   $(document).off("keydown", lockFocus);
  // }

  // function toggleModalContact(index) {
  //   if (modalsContact.eq(index).hasClass("show-modal-contactpersonen")) {
  //     closeDialogContact(index);
  //   } else {
  //     showDialogContact(index);
  //   }
  // }

  // triggersContact.on("click", function () {
  //   console.log("yes");
  //   const index = triggersContact.index(this);
  //   toggleModalContact(index);
  // });

  // closeButtonContact.on("click", function (event) {
  //   event.stopPropagation();
  //   const index = closeButtonContact.index(this);
  //   closeDialogContact(index);
  // });

  // function windowOnClickContact(event) {
  //   modalsContact.each(function (index) {
  //     if (event.target === this) {
  //       toggleModalContact(index);
  //     }
  //   });
  // }

  // $(document).on("click", windowOnClickContact);

  //form checkbox focus
  if (
    document.querySelector(".formmy") &&
    !document.querySelector(".show-modal-contact")
  ) {
    $(document).on("keydown", function (event) {
      if (event.key === "Tab") {
        setTimeout(function () {
          // console.log($(document.activeElement));
          var focusedElement = $(document.activeElement);

          if (focusedElement.is("#checkboxForm")) {
            focusedElement
              .closest(".formmy")
              .find(".checkmark")
              .css("border", "2px solid #0056c0");
          } else {
            $(".checkmark").css("border", "2px solid rgba(0, 0, 0, 0.5)");
          }
        }, 0);
      }
    });
  }

  // TRANSLATE focus

  const modalTranslate = $(".translate-menu");
  const triggerTranslate = $(".button-open-translate");
  const closebuttonTranslate = $(".button-close-translate");

  function showTranslate() {
    triggerTranslate.attr("aria-pressed", true);
    triggerTranslate.attr("aria-expanded", true);
    modalTranslate.addClass("expanded");
    modalTranslate.show();

    // const translateContent = modalTranslate.find(".translate-content");
    // if (translateContent.length && !translateContent.find("h2").length) {
    //   translateContent.prepend('<h2 class="text-cirBlack h5 dark:text-white font-degularDisplay pb-4">Translate</h2>');
    // }

    // // Move <h2> after <h1>
    // const h1 = $("h1");
    // const h2 = modalTranslate.find(".translate-content h2"); // Get the newly added <h2>

    // if (h1.length && h2.length) {
    //   h2.insertAfter(h1);
    // }

    focusableElements = [];
    focusableElements.push(closebuttonTranslate);
    focusableElements.push(modalTranslate);

    const focusableSelector = "a[href], select:not([disabled])";
    const focusableInModal = modalTranslate.find(focusableSelector);

    focusableInModal.each(function () {
      focusableElements.push($(this));
    });

    focusableElementsCurrentIndex = 0;

    // console.log(focusableElements);

    $(document).on("keydown", lockFocus);
  }

  function closeTranslate() {
    triggerTranslate.attr("aria-pressed", false);
    triggerTranslate.attr("aria-expanded", false);
    modalTranslate.removeClass("expanded");
    modalTranslate.hide();

    focusableElementsCurrentIndex = -1;
    $(document).off("keydown", lockFocus);

    // console.log("hmm closed");

    // // Listen for Tab key after modal closes
    // $(document).on("keydown", function (event) {
    //   if (event.key === "Tab") {
    //     event.preventDefault(); // Prevent default Tab behavior
    //     const nextFocusable = $(".menu-primary .menu-item.has-dropdown").first();
    //     if (nextFocusable.length) {
    //       nextFocusable.focus();
    //     }
    //     $(document).off("keydown"); // Remove event listener after execution
    //   }
    // });
  }

  triggerTranslate.on("click", function () {
    console.log("yes tt");
    showTranslate();
  });

  closebuttonTranslate.on("click", function () {
    closeTranslate();
  });

  // END TRANSLATE focus

  $(document).on("keydown", function (event) {
    if (event.key === "Tab") {
      setTimeout(function () {
        var focusedElement = $(document.activeElement);

        // Add the 'force-focus' class to the focused element
        focusedElement.addClass("force-focus");

        // Optionally, remove the 'force-focus' class from any previously focused elements
        $(".force-focus").not(focusedElement).removeClass("force-focus");

        // console.log(focusedElement);

        // var focusableElements = $('a, button, [tabindex]:not([tabindex="-1"]), input, textarea, select, [contenteditable="true"]');
        // console.log(focusableElements);
      }, 0);
    }
  });
}); //jquery
